import GlobalStyling from "@/components/web-box-styling/GlobalStyling"
import TextStyling from "@/components/web-box-styling/TextStyling"
import ImageStyling from "@/components/web-box-styling/ImageStyling"
import ColorStyling from "@/components/web-box-styling/ColorStyling"
import ButtonStyling from "@/components/web-box-styling/ButtonStyling"
import SaleStyling from "@/components/web-box-styling/SaleStyling"
import BlockStyling from "@/components/web-box-styling/BlockStyling"
import DescriptionStyling from "@/components/web-box-styling/DescriptionStyling"

import { getConfig, getCSS, CSSSelectors } from "dreamroi-box-generator"

export default {
    components: {GlobalStyling, TextStyling, ImageStyling, ColorStyling, ButtonStyling, SaleStyling, BlockStyling, DescriptionStyling},
    data() {
        return {
      
          globalConfig: {value: 'CARD', config: CSSSelectors.CARD /* [{type: 'global', selector: 'div#dreamroi-box' }] */},
          cardComponents: [
            {title: this.$t('webboxes.components.image'), value: 'IMAGE', icon: '$image', config: CSSSelectors.IMAGE /* [ {type: 'image', selector: 'img.dreamroi_product_img'} ] */ }, 
            {title: this.$t('webboxes.components.name'), value: 'NAME', icon: '$title', config: CSSSelectors.NAME /*[ {type: 'text', selector: 'div.dreamroi_product_name'}, {type: 'background', selector: 'div.dreamroi_product_name'}, {type: 'block', selector: 'div.dreamroi_product_name'}, {type: 'color', selector: 'a.dreamroi_product_href'}] */},
            {title: this.$t('webboxes.components.description'), value: 'DESCRIPTION', icon: '$description', config: CSSSelectors.DESCRIPTION /*[{type: 'text', selector: 'div.dreamroi_product_description'}, {type: 'color', selector: 'div.dreamroi_product_description'}, {type: 'background', selector: 'div.dreamroi_product_description'}, {type: 'block', selector: 'div.dreamroi_product_description'}, {type: 'description', selector: 'div.dreamroi_product_description'}]*/},
            {title: this.$t('webboxes.components.price'), value: 'PRICE', icon: '$price', config: CSSSelectors.PRICE /*[{type: 'text', selector: 'div.dreamroi_product_price'}, {type: 'color', selector: 'div.dreamroi_product_price'}, {type: 'background', selector: 'div.dreamroi_product_price'}, {type: 'block', selector: 'div.dreamroi_product_price'}]*/},
            {title: this.$t('webboxes.components.hidden'), divider: true, value: 'divider'},
            {title: this.$t('webboxes.components.button'), value: 'BUTTON', icon: '$button', config: CSSSelectors.BUTTON /* [{type: 'button', selector: 'a.dreamroi_product_btn'}, {type: 'text', selector: 'div.dreamroi_product_btn_container'}, {type: 'color', selector: 'div.dreamroi_product_btn_container'}, {type: 'background', selector: 'div.dreamroi_product_btn_container'}, {type: 'block', selector: 'div.dreamroi_product_btn_container'}] */, hidden: true},
            {title: this.$t('webboxes.components.sale'), value: 'SALE', icon: '$sale', config: CSSSelectors.SALE /*[{type: 'text', selector: 'div.dreamroi_product_salePercent'}, {type: 'color', selector: 'div.dreamroi_product_salePercent'}, {type: 'background', selector: 'div.dreamroi_product_salePercent'}, {type: 'sale', selector: 'div.dreamroi_product_salePercent'}, {type: 'block', selector: 'div.dreamroi_product_salePercent'}]*/, hidden: true}
          ],
          colorp: {
            picker: false,
            selected: null,
            prop: null,
            key: null
      },
      styling: {
        text: false,
        block: false,
        image: false,
        button: false,
        global: false,
        sale: false,
        color: false,
        background: false
      },
      // the objects are defined as the direct children of the data object so the .sync modifier works
      CSSblock: {
        padding: null,
        margin: null,
      },
      CSStext: {
        'font-size': null,
        'text-align': null,
        'font-style': null,
        'text-decoration': null,
        'font-weight': null
      },
      CSScolor: {
        color: null
      },
      CSSbackground: {
        'background-color': null
      },
      CSSbutton: {
        'background-color': null
      },
      JSbutton: {
        text: null
      },
      JSimage: {
        contain: null,
        height: null
      },
      JSsale: {
        template: null,
        defaultPercent: null
      },
      JSdescription: {
        maxLength: null
      },
      JSglobal: {
        cardWidth: null,
        gap: null,
        newTab: null,
        domMode: null,
        domId: null,
        titleContent: null,
        titleTag: null,
        titleClass: null,
        utmCampaign: null,
        customCardStyle: null,
        customArrowStyle: null,
        customSplideConfig: null,
      },
    }
    },
    computed: {
      hiddenGlobals() {
        switch(this.platform) {
          case 'SHOPIFY': return { dom: true, code: true };
          case 'SHOPTET': return { code: true };
          default: return {};
        }
      },
    },
    methods: {
        
        getConfig(component, prop, type, key) {
          /*  
          component = component.toUpperCase();
            if(!this.b.config) {
              return null;
            }
            
            if(!this.b.config[component]) {
              return null;
            }
            
            if(!this.b.config[component][prop]) {
              return null;
            }
            if(key == null) {
              return this.b.config[component][prop][type] || {};
            }
    
            if(!this.b.config[component][prop][type]) {
              return null;
            }
            
            return this.b.config[component][prop][type][key];
          */
            return getConfig(this.b.config, component, prop, type, key);
        },
        getCSS() {
            return getCSS(this.name, this.b.config);
          },
          configure(comp) {
            //console.dir(this.b.config);
            // reset styling
            Object.keys(this.styling).forEach(k => this.styling[k] = false);
            
            comp.config.forEach(i => {
              // show the styling component
              this.styling[i.type] = true;
              var currentcss = this.getConfig(comp.value, i.type, 'css');
              var currentjs = this.getConfig(comp.value, i.type, 'js');
              //console.debug('Current setup:');
              //console.debug(`${comp.value} ${i.type}`)
              //console.dir(currentcss);
              //console.dir(currentjs);
              /*
              this.styling[i.type] = { 
                css: { 
                  
                  //...props[i.type],
                  ...currentcss
                }, 
                js: {  
                  ...currentjs
                }
              }
              */
             let prep = (x, current) => {
                if(this[`${x}${i.type}`]) {
                    // reset current values
                    let template = {}; 
                    Object.keys(this[`${x}${i.type}`]).forEach(k => template[k] = null);   
                    // copy current setup
                    this[`${x}${i.type}`] = Object.assign(template, current);
                }
             };
             prep('CSS', currentcss);
             prep('JS', currentjs);
            
              if(!this.b.config) {
                this.b.config = {};
              }
              if(!this.b.config[comp.value]) {
                this.b.config[comp.value] = {};
              }
              /*
              if(!this.b.config[comp.value][i.type]) {
                console.debug('Assigning to the config...');
                this.b.config[comp.value][i.type] = {
                  css: this[`CSS${i.type}`],
                  js: this[`JS${i.type}`]
                }
              }
              */
            this.b.config[comp.value][i.type] = {
                css: this[`CSS${i.type}`],
                js: this[`JS${i.type}`]
              }
            });
            this.configPanel = true;
          },
          openPicker({prop, key}) {
              this.colorp.prop = prop;
              this.colorp.key = key;
              this.colorp.selected = this[`CSS${prop}`][key];
              this.colorp.picker = true;
          },
          updateColor() {
            this.colorp.picker = false;
            let val = typeof(this.colorp.selected) === 'string' ? this.colorp.selected : this.colorp.selected.hexa
            this[`CSS${this.colorp.prop}`][this.colorp.key] = val;
          },
    }
}